import { useQuery } from "@tanstack/react-query";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { ListMemberWithEmail } from "../../types";

// The Owner's manage panel: every Member and unanswered Invitation on one
// List, with the email each row is about. list_member_directory() itself
// enforces that only the List's Owner gets rows back — see the migration
// for why this is a database function rather than a client-side join
// (auth.users isn't reachable through PostgREST at all).
export async function fetchListMemberDirectory(listId: string): Promise<ListMemberWithEmail[]> {
  const { data, error } = await supabase.rpc("list_member_directory", { p_list_id: listId });
  if (error) throw error;
  return (data ?? []) as ListMemberWithEmail[];
}

export function useListMemberDirectory(listId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.listMemberDirectory(listId ?? ""),
    queryFn: () => fetchListMemberDirectory(listId as string),
    enabled: enabled && !!listId,
  });
}
